import { Card } from "@mui/material";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useCustomerValue } from "providers/CustomerContext";
import { useState, useEffect,useMemo } from "react";
import { Link } from "react-router-dom";
import {
  getInventorySKUList,
  getCustomerCode,
  getVendorCodeFromCustomer,
  getZone,
  getLocation,
  getOLN,
  getMLN,
  getCartonID,
  getDistinctSKUCode,
  getDistinctSKUCategory,
  getDistinctSKUGroup,
  getDistinctSKUSubgroup,
  getPhysicalCountList,
  getPhysicalCountList2,
  getPhysicalNoList,
  retrievePhysicalCountList,
  retrievePhysicalCountListOnly,
  getPhyOpnBalScan,
  getPhyOpnBalScanComparison,
  getPhyOpnBalScan3,
  uploadPhyOpnBalScanComparison,
  updateCountList,
  updateFinalCountList,
  forceclose,
  consolidate,
  retrieveCountSummaryLookup,
  retrievePCountList,
  retrieveLatestCountList,
  getadjustmentreasoncode,
} from "services/data.inventory.service";
import { LoadingDialog } from "ui-components/Alert";
import { ListLayout } from "ui-components/Layout";
import ServerTable from "ui-components/tables/ServerTable";
import BasicTabs from "ui-components/tabs/BasicTabs";
import dayjs from "dayjs";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { createSO } from "services/data.outbound.service";
import { InboundLayout } from "ui-components/Layout";
import { InboundHeaderCard } from "ui-components/Layout";
import {
  FormTitle,
  InboundSubmitButton,
  DatePickerField,
  Text,
  SelectField,
} from "ui-components/Form";
import { Grid,Icon } from "@mui/material";
//import SO from "./components/SO";
//import { headerRender, headerValues, headerValidation } from "./physical-count-schema";
import { SelectFields } from "ui-components/Form";
import { Fieldset } from "ui-components/Form";
import switchButton from "assets/theme/components/form/switchButton";
import Switch from "@mui/material/Switch";
import { SwitchField } from "ui-components/Form";
import { TableCard } from "ui-components/Layout";
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import BasicTable from "ui-components/tables/BasicTable";
import { CustomSwitch } from "ui-components/CustomInput";
import { ReadonlyText } from "ui-components/Form";
import { Formik, Form } from "formik";
import { uploadPC } from "services/data.inventory.service";
import {
  physicalCountListcolumns,
  physicalCountListLookup,
  latestCountListcolumns,
} from "./columns";
import { Success, Error_ ,ExportDialog } from "ui-components/Alert";
import { EditableSelect, EditableText, EditableNumber } from "ui-components/EditableInput2";
import { getVendorSKUList2 } from "services/data.internal.service";
import CheckboxTable2 from "ui-components/tables/CheckboxTable2";
import { MenuBookRounded } from "@mui/icons-material";
import { useTeamValue } from "providers/TeamContext";
import MDTypography from "components/MDTypography";
import useCsvDownloadHook from "hooks/useCsvDownloadHook";
import { StripedDataGrid } from "ui-components/data-grids/StripedCheckboxDataGrid";
import AddPhysicalCountDialog from "./dialog";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button
} from "@mui/material";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
// import Dialog from "@mui/material/Dialog";
// import DialogTitle from "@mui/material/DialogTitle";
// import DialogContent from "@mui/material/DialogContent";
// import DialogActions from "@mui/material/DialogActions";
// import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
//import Button from "@mui/material/Button";
import * as XLSX from "xlsx";

function UpdatePhysicalCount({ zoneLocationAisle }) {
  const { permissions, allowAll } = useTeamValue();
  const editPermission =
    allowAll ||
    (Boolean(permissions["Physical Count"]) &&
      permissions["Physical Count"].findIndex((b) => b === "edit") !== -1);
  const { customerCode } = useCustomerValue();
  console.log(customerCode);
  const { pCountNo } = useState("");
  const [alert, setAlert] = useState(null);
  const [status, setStatus] = useState("");
  const [pnos, setPNOs] = useState([]);
  const [selectedPNO, setSelectedPNO] = useState(null);
  //const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  const onError = (error, setAlert) => {
    setAlert(null); // Clear any existing alert
    setAlert(<Error_ data={error} onChange={setAlert} />);
  };
  const onSuccess = (data, setAlert) => {
    setAlert(null); // Clear any existing alert
    setAlert(<Success data={data} onChange={setAlert} />);
  };
  const tabs = ["Physical Count List", "Count Summary Lookup", "Latest Count Data", "Consolidate"];
  //const uploadPCMutation = useMutation(uploadPC, {});
  const uploadPCMutation = useMutation(uploadPC, {
     onSuccess: (data) => {
       document.getElementById("files").value = null;
       setUploadResps(data.data.data);
       onSuccess(data, setAlert);
     },
     onError: (error) => onError(error, setAlert),
  });
  const uploadStatus = uploadPCMutation.status === "loading";
  const [uploadResps, setUploadResps] = useState([]);
  const { isFetchingPNo, refetch: refetchPNo } = useQuery({
    queryKey: ["PNOOption", { customerCode }],
    queryFn: () => getPhysicalNoList(customerCode),
    enabled: true,
    onSuccess: (data) => {
      if (data && data.data) {
        setPNOs(data.data.data);
      }
    },
    //onError,
    onError: (error) => onError(error, setAlert),
  });

  const getphysicalcountMutation = useMutation(
    (requestdata) => getPhysicalCountList2(requestdata),
    {
      onSuccess: (data) => {
        const { pCountNo } = data.data;
        console.log("PCountNo:", pCountNo);
        retrievePhysicalCountListOnly(pCountNo).then((response) => {
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${pCountNo}.xlsx`);
          document.body.appendChild(link);
          link.click();
        });
        // queryClient.invalidateQueries(["exception-list"]);
        // setAlert(<Success data={data} onChange={setAlert} />);
      },
      //onError,
      onError: (error) => onError(error, setAlert),
    }
  );

  const handleDownload = () => {
    console.log(selectedPNO); // Log the selected value
    // Add code here to handle the download
    retrievePhysicalCountListOnly(selectedPNO).then((response) => {
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${selectedPNO}.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  };

  const handleSubmit = (values, actions) => {
    setAlert(null);
    let formData = new FormData();
    formData.append("files", values.files[0], values.files[0].name);
    formData.append("customerCode", customerCode);
    formData.append("PCountNo", selectedPNO);
    formData.append("vendorCode", values.vendorCode);
    uploadPCMutation.mutate(formData, {
      onSuccess: (data) => {
        console.log("Success responsefromsubmit:", data); // Log success response
        document.getElementById("files").value = null;
        //  document.getElementById("files").value = null;
        //  actions.setFieldValue("vendorCode", "");
        //  actions.resetForm();
        setUploadResps(data.data.data);
        console.log("after set upload response");
        const uploadData = data.data.data; 
        if (uploadData.length > 0) {
          setAlert(<Error_ content="Please refer to the excel file for the issue." onChange={setAlert} />);
      } else {
          setAlert(<Success content="File is uploaded successfully." onChange={setAlert} />);
      }
        //setAlert(<Success content="File is uploaded successfully." onChange={setAlert} />);
      },
      //onError,
      //onError: (data) => setAlert(<Error_ data={data} onChange={setAlert} />),
      onError: async (data) => {
        //  let content = await data.response.data.text();
        //  if (content.includes("No data")) {
        //    content = "No data";
        //  }
         setAlert(<Error_ content={"Please refer to the excel file for the issue."} onChange={setAlert} />);
        //setAlert(<Error data={data} onChange={setAlert} />);
      },
      // onError: (error) => {
      //   console.error("Error response:", error);
      //   const errorMessage =
      //     error.response?.data?.message ||
      //     "There is problem with uploaded file. Please check carefully.";
      //   onError(error, setAlert);
      //   setAlert(<Error_ data={error} onChange={setAlert} />);
      // },
    });
    actions.setSubmitting(false);
    // actions.resetForm(true);
  };

  const {downloadCsv, isDownloading} = useCsvDownloadHook();

  useEffect(() => {
    refetchPNo(); // Trigger the query to fetch data
  }, []);

  useEffect(() => {
    if (uploadResps.length > 0) {
      const filename = `${customerCode}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_Physicalcount`;
      const headers = [
        { label: "Physical Count No", key: "pCountNo" },
        { label: "Customer Code", key: "customerCode" },
        { label: "SKU Code", key: "skuCode" },
        { label: "Zone Id", key: "zoneID" },
        { label: "Location Id", key: "locationID" },
        { label: "Carton Id", key: "cartonID" },
        { label: "Quantity", key: "sysQty" },
        { label: "MLN", key: "mln" },
        { label: "Retail Barcode", key: "retailBarcode" },
        { label: "Expiry Date", key: "expiryDate" },
        { label: "Message", key: "message" },
      ];
  
      // Auto download CSV
      downloadCsv(filename, uploadResps.filter((x) => !x.success), headers);
    }
  }, [uploadResps]); // Runs when `uploadResps` changes
  

  const render = () => {
    let task;
    switch (status) {
      case "Physical Count List":
        console.log("pnos value:", selectedPNO);
        console.log("customerCode value:", customerCode);
        task = (
          <PCountList
            //columns={columns}
            customerCode={customerCode}
            pnos={selectedPNO}
            // userOptions={userOptions}
            // szOptions={szOptions}
            // categoryOptions={categoryOptions}
            // list={list}
            // setList={setList}
            // onPreallocate={onPreallocate}
            // setAlert={setAlert}
            editPermission={editPermission}
          />
        );
        break;

      case "Count Summary Lookup":
        task = (
          <PCountSummaryLookUp
            customerCode={customerCode}
            pnos={selectedPNO}
            onError={onError}
            editPermission={editPermission}
          />
        );
        break;
      case "Latest Count Data":
        task = (
          <CountData
            customerCode={customerCode}
            pnos={selectedPNO}
            onError={onError}
            editPermission={editPermission}
          />
        );
        break;
      case "Consolidate":
        task = (
          <Consolidate
            customerCode={customerCode}
            pnos={selectedPNO}
            onError={onError}
            refetchPNo={refetchPNo}
            editPermission={editPermission}
            setSelectedPNO = {setSelectedPNO}
          />
        );
        break;
      case "Allocation Queue":
        task = <AllocationQueue customerCode={customerCode} />;
        break;
      case "Demo":
        task = <Demo2 customerCode={customerCode} />;
        break;
    }

    return task;
  };

  return (
    <InboundLayout lg={12}>
      {alert}
      {isDownloading && <ExportDialog />}
      <InboundHeaderCard>
        <FormTitle title={"Update Physical Count"} />
        <MDBox display="flex">
          <Fieldset label="Please choose a physical count to proceed">
            <Grid container spacing={3}>
              <Grid item xs={4}>
                <SelectFields
                  field={{
                    name: "",
                    label: "",
                    value: selectedPNO,
                    errors: {},
                  }}
                  options={pnos}
                  onChange={(e, v) => setSelectedPNO(v)}
                />
              </Grid>

              <Grid item xs={1.5}>
                <MDButton
                  color="info"
                  variant="gradient"
                  onClick={handleDownload}
                  disabled={selectedPNO === null || selectedPNO.trim() === ""}
                >
                  Download CountSheet
                </MDButton>
              </Grid>
            </Grid>
          </Fieldset>
          <Fieldset sx={{ marginLeft: "1rem" }} label="Upload physical count data">
            <Formik initialValues={{ files: [] }} onSubmit={handleSubmit}>
              {({ values, setFieldValue }) => (
                <Form>
                  <MDBox>
                    <input
                      type="file"
                      name="files"
                      id="files"
                      onChange={(e) => {
                        setUploadResps([]);
                        setFieldValue("files", e.target.files);
                      }}
                    />
                    <MDButton
                      style={{ marginLeft: "3rem" }}
                      type="submit"
                      variant="gradient"
                      color="info"
                      disabled={
                        values.files.length == 0 ||
                        uploadStatus ||
                        selectedPNO === null ||
                        selectedPNO.trim() === ""
                      }
                    >
                      {uploadStatus ? "Uploading" : "Upload"}
                    </MDButton>
                  </MDBox>
                </Form>
              )}
            </Formik>
           
            {/* <Grid item xs={1.5}>
                  <MDButton color="info" variant="gradient" onClick={handleDownload}>
                    Upload
                  </MDButton>
                </Grid> */}
          </Fieldset>
        </MDBox>
             {/* <StripedDataGrid
                           columns={[
                             {
                               headerName: "Status",
                               field: "success",
                               align: "center",
                               renderCell: (cell) =>
                                 cell.row.success ? (
                                   <StatusIcon color="success" icon="done" />
                                 ) : (
                                   <StatusIcon color="error" icon="close" />
                                 ),
                             },
                             { headerName: "Physical Count No", field: "pCountNo", width: 100 },
                             { headerName: "Customer Code", field: "customerCode", width: 100 },
                             { headerName: "SKU Code", field: "skuCode", width: 100 },
                             { headerName: "Zone Id", field: "zoneID", width: 100 },
                             { headerName: "Location Id", field: "locationID", width: 100 },
                             { headerName: "Carton Id", field: "cartonID", width: 100 },
                             { headerName: "Quantity", field: "sysQty", width: 100 },
                             { headerName: "MLN", field: "mln", width: 100 },
                             { headerName: "Retail Barcode", field: "retailBarcode", width: 100 },
                             { headerName: "Expiry Date", field: "expiryDate", width: 110 },
                            //  { headerName: "Manu.Date", field: "manufacturingDate", width: 110 },
                             // { headerName: "Cust Order Number", field: "custOrdNbr", width: 200 },
                             {
                               headerName: "Message",
                               field: "message",
                               //flex: 1,
                               //wordWrapEnabled: true,
                               width: 1200,
                               renderCell: (cell) => (
                                 <div>
                                   {cell.row.message.map((c, i) => (
                                     <p key={i}>{c}</p>
                                   ))}
                                 </div>
                               ),
                             },
                           ]}
                           rows={uploadResps}
                           getRowHeight={(cell) => {
                             if (cell.model.message.length > 2) {
                               return "auto";
                             } else {
                               return 50;
                             }
                           }}
                         /> */}
        {/* </ListLayout> */}
      </InboundHeaderCard>
      <InboundHeaderCard>
        <BasicTabs tabs={tabs} status={status} setStatus={setStatus} />

        <MDBox>{render()}</MDBox>
      </InboundHeaderCard>
    </InboundLayout>
  );
}

const StatusIcon = ({ color, icon }) => (
  <MDButton color={color} variant="outlined" size="small" iconOnly circular>
    <Icon sx={{ fontWeight: "bold" }}>{icon}</Icon>
  </MDButton>
);

export default UpdatePhysicalCount;

function PCountList({ pnos, customerCode, zoneID, onError, editPermission }) {
  console.log(zoneID,"from pcountlist");
  const [type, setType] = useState("ALL");
  const [list, setList] = useState([]);
  const [data, setData] = useState([]);
  const queryClient = useQueryClient();
  const [alert, setAlert] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [columnFilter, setColumnFilter] = useState([{ id: "zoneID", value: zoneID }]);
  const { isFetching, refetch } = useQuery({
    queryKey: ["phyopnbalscan-details", "list", { customerCode, pnos }],
    queryFn: () => getPhyOpnBalScan({ customerCode, pnos }),
    enabled: !!pnos,
    onSuccess: (data) => {
    setList(data.data.data);
    setOriginalList(data.data.data.map((row) => ({ ...row })));
  },
    onError: (data) => {
      setAlert(<Error_ data={data} onChange={setAlert} />);
    },
  });
  const [originalList, setOriginalList] = useState([]);
  const visibleColumns = physicalCountListcolumns.filter(
    (col) => !["skuDescription", "retailBarcode"].includes(col.accessorKey)
  );
   const handleDownload = () => {
  const statusLabels = {
    C: "Data Uploaded",
    P: "Complete Scanning",
    O: "In Scanning",
  };

  const exportRows = filteredData.map((row) => {
    const rowData = {};
    physicalCountListcolumns.forEach((col) => {
      const value = row[col.accessorKey];
      if (col.accessorKey === "status") {
        rowData[col.header] = statusLabels[value] ?? value ?? "";
      } else {
        rowData[col.header] = col.exportFormat ? col.exportFormat(value) : value ?? "";
      }
    });
    return rowData;
  });

  const worksheet = XLSX.utils.json_to_sheet(exportRows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Physical Count List");
  XLSX.writeFile(workbook, "PhysicalCountList.xlsx");
};

  const updateCountListMutation = useMutation(updateCountList, {
    onSuccess: (list) => {
      queryClient.invalidateQueries(["phyopnbalscan-details"]);
      setAlert(<Success data={list} onChange={setAlert} />);
    },
    //onError,
    onError: (data) => {
      console.log(data);
      setAlert(<Error_ data={data} onChange={setAlert} />);
    },
  });

  const handleretrieve = () => {
    refetch();
  };

  // const onSubmit = () => {
  //   console.log(list);
  //   updateCountListMutation.mutate(list);
  // };

  const onSubmit = () => {
  const changedRows = list.filter((row, index) => {
    const original = originalList[index];
    return original && row.countQty !== original.countQty;
  });

  console.log(changedRows, "changedRows");

  if (changedRows.length === 0) {
    setAlert(<Error_ data={{ message: "No changes to update" }} onChange={setAlert} />);
    return;
  }

  updateCountListMutation.mutate(changedRows);
};

  const [openAddDialog, setOpenAddDialog] = useState(false);

const [newRow, setNewRow] = useState({
    skuCode: "",
    location: "",
    batchNo: "",
    expiryDate: null,
    quantity: 0,
});

  return (
    <>
      {isFetching && <LoadingDialog />}
      {alert}
      {/* <Grid item xs={1.5}> */}

      {/* </Grid> */}
      {/* <BasicTable sx={{ mt: "1rem" }} {...tableProps} 
      //onFilterRowsChange={handleChange} 
      /> */}
      <TableCard sx={{ mt: "1rem" }}>
        <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" margin="10px">
          <MDBox display="flex" gap={1}>
          <MDButton
            color="info"
            variant="gradient"
            onClick={handleretrieve}
            disabled={pnos === null || pnos.trim() === ""}
            sx={{ mr: 2 }}
          >
            Retrieve
          </MDButton>
          <MDButton
            color="info"
            variant="gradient"
            onClick={handleDownload}
            disabled={customerCode === null}
            sx={{ mr: 2 }}
          >
            Export
          </MDButton>
           <MDButton
             color="info"
             variant="gradient"
             onClick={() => setOpenAddDialog(true)}
             sx={{ mr: 2 }}
           >
             Add Row
           </MDButton>
          </MDBox>
          <MDBox
      sx={{
        backgroundColor: "#f8d7da", // Light red background
        color: "#721c24", // Dark red text
        padding: "10px",
        borderRadius: "5px",
        fontSize: "14px",
        fontWeight: "bold",
        display: "inline-block",
      }}
    >
      You are not allowed to modify data here after uploading count data.
    </MDBox>
        </MDBox>
        

        <CheckboxTable2 data={list} columns={visibleColumns} setData={setList} onFilterRowsChange={setFilteredData} />
      </TableCard>
      <AddPhysicalCountDialog
        open={openAddDialog}
    onClose={() => setOpenAddDialog(false)}
    onSave={(row) => {
        setList(prev => [...prev, row]);
    }}
     customerCode={customerCode}
    zoneID={zoneID}
    pCountNo={pnos}
    setAlert={setAlert}
      />
      {/* <Dialog
    open={openAddDialog}
    onClose={() => setOpenAddDialog(false)}
    maxWidth="md"
    fullWidth
>
    <DialogTitle>Add New Item</DialogTitle>

    <DialogContent>
      <TextField
            margin="dense"
            label="Zone ID"
            fullWidth
            value={newRow.location}
            onChange={(e) =>
                setNewRow({
                    ...newRow,
                    location: e.target.value,
                })
            }
        />
      <TextField
            margin="dense"
            label="Location ID"
            fullWidth
            value={newRow.location}
            onChange={(e) =>
                setNewRow({
                    ...newRow,
                    location: e.target.value,
                })
            }
        />
        <TextField
            margin="dense"
            label="Carton Id"
            fullWidth
            value={newRow.location}
            onChange={(e) =>
                setNewRow({
                    ...newRow,
                    location: e.target.value,
                })
            }
        />
        <TextField
            margin="dense"
            label="SKU Code"
            fullWidth
            value={newRow.skuCode}
            onChange={(e) =>
                setNewRow({
                    ...newRow,
                    skuCode: e.target.value,
                })
            }
        />
        <TextField
            margin="dense"
            label="Count Quantity"
            type="number"
            fullWidth
            value={newRow.quantity}
            onChange={(e) =>
                setNewRow({
                    ...newRow,
                    quantity: Number(e.target.value),
                })
            }
        />
        <TextField
            margin="dense"
            label="MLN"
            fullWidth
            value={newRow.location}
            onChange={(e) =>
                setNewRow({
                    ...newRow,
                    location: e.target.value,
                })
            }
        />
        <TextField
            margin="dense"
            label="Expiry Date"
            fullWidth
            value={newRow.location}
            onChange={(e) =>
                setNewRow({
                    ...newRow,
                    location: e.target.value,
                })
            }
        />

    </DialogContent>

    <DialogActions>

        <Button
            onClick={() => setOpenAddDialog(false)}
        >
            Cancel
        </Button>

        <Button
            variant="contained"
            //onClick={handleSaveRow}
        >
            Save
        </Button>

    </DialogActions>
</Dialog> */}
      <InboundSubmitButton label="Update" onClick={onSubmit} disabled={!editPermission} />
    </>
  );
}

function PCountSummaryLookUp({ pnos, customerCode, editPermission }) {
  const [list, setList] = useState([]);
  const [type, setType] = useState("ALL");
  const [alert, setAlert] = useState(null);
  const onError = (data) => setAlert(<Error_ data={data} onChange={setAlert} />);
  console.log(pnos);
  const exportOnlyColumns = [
    { header: "SKU Description", accessorKey: "skuDescription" },
    { header: "Retail Barcode", accessorKey: "retailBarcode" },
  ];
  //const exportColumns = [...physicalCountListLookup, ...exportOnlyColumns];
  // Find index of the SKU Code column (adjust accessorKey if it's named differently)
  const skuCodeIndex = physicalCountListLookup.findIndex(
    (col) => col.accessorKey === "skuCode"
  );
  const exportColumns =
  skuCodeIndex === -1
    ? [...physicalCountListLookup, ...exportOnlyColumns] // fallback if not found
    : [
        ...physicalCountListLookup.slice(0, skuCodeIndex + 1),
        ...exportOnlyColumns,
        ...physicalCountListLookup.slice(skuCodeIndex + 1),
      ];
  const { isFetching, refetch } = useQuery({
    queryKey: ["phyopnbalscan-details", "comparison", { customerCode, pnos, type }],
    queryFn: () => getPhyOpnBalScanComparison({ pnos, type, customerCode }),
    enabled: !!pnos,
    onSuccess: (data) => setList(data.data.data),
    onError,
  });
const [filteredData, setFilteredData] = useState([]);
  const [openPdfDialog, setOpenPdfDialog] = useState(false);
const [pdfTitle, setPdfTitle] = useState("Count Summary Lookup");
const [selectedColumns, setSelectedColumns] = useState(
  exportColumns.map((col) => col.accessorKey)
);

const handleColumnToggle = (key) => {
  setSelectedColumns((prev) =>
    prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
  );
};

const handleExportPDF = () => {
  const doc = new jsPDF({ orientation: "landscape" });
  const pageWidth = doc.internal.pageSize.getWidth();

  // --- Left side: Title + subtitle ---
  doc.setFontSize(14);
  doc.setFont(undefined, "bold");
  doc.text(pdfTitle, 14, 15);

  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  doc.text(`Physical Count No : ${pnos || ""}`, 14, 21);

  // --- Right side: Date / Page / Printed By ---
  const now = new Date();
  const formattedDate = now.toLocaleString("en-US", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }).replace(",", "");

  doc.setFontSize(10);
  doc.text(`Date : ${formattedDate}`, pageWidth - 14, 12, { align: "right" });
  //doc.text(`Printed By : ${printedBy || ""}`, pageWidth - 14, 22, { align: "right" });
  // "Page : x / y" is added after autoTable runs, since total pages isn't known yet

  // --- Table ---
  const columnsToExport = exportColumns.filter((col) =>
    selectedColumns.includes(col.accessorKey)
  );

  const head = [columnsToExport.map((col) => col.header)];
  const body = filteredData.map((row) =>
    columnsToExport.map((col) => col.exportFormat ? col.exportFormat(row[col.accessorKey]) : row[col.accessorKey] ?? "")
  );

  autoTable(doc, {
    head,
    body,
    startY: 28,
    styles: { fontSize: 8 },
    headStyles: { fillColor: [26, 115, 232] },
  });

  // --- Page numbers (needs total page count, so added last) ---
  // const pageCount = doc.internal.getNumberOfPages();
  // for (let i = 1; i <= pageCount; i++) {
  //   doc.setPage(i);
  //   doc.setFontSize(10);
  //   doc.text(`Page : ${i} / ${pageCount}`, pageWidth - 14, 17, { align: "right" });
  // }
  // --- Totals footer (last page only, right after the table ends) ---
  const finalY = doc.lastAutoTable.finalY || 28;
  const pageHeight = doc.internal.pageSize.getHeight();

  let footerY = finalY + 10;
  if (footerY > pageHeight - 15) {
    doc.addPage();
    footerY = 15;
  }
  doc.setFontSize(9);
  doc.setFont(undefined, "bold");
  doc.text(`Total SysQty: ${totals.sysQty}`, 14, footerY);
  doc.text(`Total CountQty: ${totals.countQty}`, 80, footerY);
  doc.text(`Total Variance: ${totals.variance}`, 150, footerY);

  doc.save(`${pdfTitle.replace(/\s+/g, "_")}.pdf`);
  setOpenPdfDialog(false);
};

  // const handleDownload = () => {
  //   retrieveCountSummaryLookup({ pnos, type, customerCode }).then((response) => {
  //     const blob = new Blob([response.data], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });
  //     const url = window.URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", `PCountSummaryLookup.xlsx`);
  //     document.body.appendChild(link);
  //     link.click();
  //   });
  // };
  const handleDownload = () => {
  const exportRows = filteredData.map((row) => {
    const rowData = {};
    exportColumns.forEach((col) => {
      rowData[col.header] = col.exportFormat ? col.exportFormat(row[col.accessorKey]) : row[col.accessorKey] ?? "";
    });
    return rowData;
  });

  const worksheet = XLSX.utils.json_to_sheet(exportRows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Count Summary");
  XLSX.writeFile(workbook, "PCountSummaryLookup.xlsx");
};

  // const upload = async () =>{
  //   try{
  //     console.log("pnos",pnos);
  //     console.log("type",type);
  //     console.log("customerCode",customerCode);
  //     const response = uploadPhyOpnBalScanComparison({pnos,type,customerCode});
  //     console.log("doneupload");
  //     setAlert(<Success data={response.data} onChange={setAlert} />);
  //   }
  //   catch (error){
  //     console.error("Upload error:", error);
  //     setAlert(<Error data={error.response.data} onChange={setAlert} />);
  //   }
  // }
  const createConsigneeMutation = useMutation(
    //uploadPhyOpnBalScanComparison,
    ({ pnos, type, customerCode }) => uploadPhyOpnBalScanComparison({ pnos, type, customerCode }),
    {
      onSuccess: (data) => setAlert(<Success data={data} onChange={setAlert} />),
      onError,
    }
  );

  const createConsigneeMutationStatus = createConsigneeMutation.status === "loading"
  
  const onSubmit = () => {
    createConsigneeMutation.mutate(
      { pnos, type, customerCode },
      {
        onSuccess: () =>
          //reset(),
          {},
      }
    );
  };

  const tableProps = {
    data: list,
    columns: physicalCountListLookup,
  };

  const totals = useMemo(() => {
    return list.reduce(
      (acc, item) => {
        acc.sysQty += item.sysQty || 0;
        acc.countQty += item.countQty || 0;
        acc.variance += item.variance || 0;
        return acc;
      },
      { sysQty: 0, countQty: 0, variance: 0 } // Initial values
    );
  }, [list]);

  return (
    <>
    <TableCard sx={{ mt: "1rem" }}>
      {(isFetching || createConsigneeMutationStatus) && <LoadingDialog />}
      {alert}
      <Grid sx={{ padding: "10px 0 0 10px" }} container spacking={3} justifyContent="space-between">
        <Grid item>
          
          <MDButton
            color="info"
            variant="gradient"
            onClick={onSubmit}
            disabled={list.length === 0 || type !== "ALL" || !editPermission}
            sx={{ mr: 2 }}
          >
            Upload Count Data
          </MDButton>
          <MDButton
            color="info"
            variant="gradient"
            onClick={handleDownload}
            disabled={customerCode === null}
            sx={{ mr: 2 }}
          >
            Export Excel
          </MDButton>
          <MDButton
  color="info"
  variant="gradient"
  onClick={() => setOpenPdfDialog(true)}
  disabled={customerCode === null}
  sx={{ mr: 2 }}
>
  Export PDF
</MDButton>
        </Grid>
        <Grid item sx={{ textAlign: "right", display: "flex", gap: "2rem" }}>
    <div>
      <strong>Total SysQty:</strong> {totals.sysQty}
    </div>
    <div>
      <strong>Total CountQty:</strong> {totals.countQty}
    </div>
    <div>
      <strong>Total Variance:</strong> {totals.variance}
    </div>
  </Grid>
      </Grid>
      <Grid sx={{ paddingLeft: "12px" }} container spacing={3}>
        <Grid item>
          <FormControl>
            <RadioGroup
              row
              onChange={(e) => {
                setType(e.target.value);
              }}
            >
              <FormControlLabel
                labelPlacement="left"
                value="ALL"
                label="All"
                control={
                  <Radio
                    sx={{ "& .MuiSvgIcon-root": { border: "1px solid #1A73E8" } }}
                    checked={type === "ALL"}
                  />
                }
              />
              <FormControlLabel
                labelPlacement="left"
                value="POSITIVE"
                label="Variance"
                control={
                  <Radio
                    sx={{ "& .MuiSvgIcon-root": { border: "1px solid #1A73E8" } }}
                    checked={type === "POSITIVE"}
                  />
                }
              />
              {/* <FormControlLabel
                labelPlacement="left"
                value="NEGATIVE"
                label="Negative Variance"
                control={
                  <Radio
                    sx={{ "& .MuiSvgIcon-root": { border: "1px solid #1A73E8" } }}
                    checked={type === "NEGATIVE"}
                  />
                }
              /> */}
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>

      <BasicTable {...tableProps} onFilterRowsChange={setFilteredData} />
    </TableCard>
    <Dialog open={openPdfDialog} onClose={() => setOpenPdfDialog(false)} maxWidth="xs" fullWidth>
  <DialogTitle>Export to PDF</DialogTitle>
  <DialogContent>
    <TextField
      margin="dense"
      label="PDF Title"
      fullWidth
      value={pdfTitle}
      onChange={(e) => setPdfTitle(e.target.value)}
      sx={{ mb: 2 }}
    />
    <strong>Select Columns</strong>
    <FormGroup>
  {exportColumns.map((col) => (
    <FormControlLabel
      key={col.accessorKey}
      control={
        <Checkbox
          checked={selectedColumns.includes(col.accessorKey)}
          onChange={() => handleColumnToggle(col.accessorKey)}
        />
      }
      label={col.header}
    />
  ))}
</FormGroup>
  </DialogContent>
  <DialogActions>
    <MDButton
    color="secondary"
    variant="gradient"
    onClick={() => setOpenPdfDialog(false)}
  >
    Cancel
  </MDButton>
  <MDButton
    color="info"
    variant="gradient"
    onClick={handleExportPDF}
    disabled={selectedColumns.length === 0}
  >
    Export
  </MDButton>
  </DialogActions>
</Dialog>
</>
  );
}

function CountData({ pnos, customerCode, zoneID, onError, editPermission }) {
  const [list, setList] = useState([]);
  const queryClient = useQueryClient();
  const [alert, setAlert] = useState(null);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);
  const active = true;
  const [columnFilter, setColumnFilter] = useState([{ id: "zoneID", value: zoneID }]);
  const latestCountListcolumns2 = [
    {
      header: "Zone ID",
      accessorKey: "zoneID",
    },
    {
      header: "Location ID",
      accessorKey: "locationID",
    },
    {
      header: "Carton Id",
      accessorKey: "cartonID",
    },
    {
      header: "Vendor Code",
      accessorKey: "vendorCode",
      // cell: (props) => {
      //   const { row } = props;
      //   const options = row.original.vendorOptions || []; // Use vendor options specific to this row's SKU code
      //   return EditableSelect({
      //     ...props,
      //     options,
      //     value: props.cell.getValue()?.value,
      //   });
      // },
      // ...{ cell: (props) => EditableSelect({
      //   ...props,
      //   options:vendorOptions,
      //   value: props.cell.getValue().value,
      // }) },
    },
    {
      header: "SKU Code",
      accessorKey: "skuCode",
    },
    {
      header: "Sys Qty",
      accessorKey: "sysQty",
    },
    {
      header: "Count Qty",
      accessorKey: "phyQty",
      ...{ cell: EditableNumber },
    },
    {
      header: "Variance",
      accessorKey: "variance",
    },
    {
      header: "MLN",
      accessorKey: "mln",
    },
    {
      header: "Expiry Date",
      accessorKey: "expiryDate",
      cell: ({ getValue }) => {
        const dateValue = getValue();
        if (!dateValue) {
          return ""; // Return empty string if the expiry date is null or empty
        }
        const formattedDate = new Date(dateValue).toLocaleDateString("en-GB"); // Format the date to "DD/MM/YYYY" or based on the user's locale
        return formattedDate;
      },
    },
    // {
    //   header: "Retail Barcode",
    //   accessorKey: "retailBarcode",
    // },
  ];
  const exportOnlyColumns = [
    { header: "SKU Description", accessorKey: "skuDescription" },
    { header: "Retail Barcode", accessorKey: "retailBarcode" },
  ];
  const skuCodeIndex = physicalCountListLookup.findIndex(
    (col) => col.accessorKey === "skuCode"
  );
  const exportColumns =
  skuCodeIndex === -1
    ? [...physicalCountListLookup, ...exportOnlyColumns] // fallback if not found
    : [
        ...physicalCountListLookup.slice(0, skuCodeIndex + 1),
        ...exportOnlyColumns,
        ...physicalCountListLookup.slice(skuCodeIndex + 1),
      ];
  //const exportColumns = [...latestCountListcolumns2, ...exportOnlyColumns];
  const { isFetching, refetch } = useQuery({
    queryKey: ["phyopnbalscan-details", "latest", { customerCode, pnos }],
    queryFn: () => getPhyOpnBalScan3({ pnos, customerCode }),
    enabled: !!pnos,
    // onSuccess: async (data) => {
    //   const listData = data.data.data;
    //   console.log("Fetched listData:", listData);
    //   // setList(listData);
    //   // const skuCodes = listData.map(item => item.skuCode); // Extract skuCodes from the list
    //   // console.log("skucodes" , skuCodes);
    //   // fetchVendorList(skuCodes); // Fetch vendor list using skuCodes
    //   const updatedList = await Promise.all(
    //     listData.map(async (item) => {
    //       const skuCode = item.skuCode;
    //       console.log("Processing skuCode:", skuCode);

    //       try {
    //         const vendorOptions = await fetchVendorList(skuCode);
    //         return {
    //           ...item,
    //           vendorOptions, // Add vendorOptions to each item
    //         };
    //       } catch (error) {
    //         console.error(`Error fetching vendor list for SKU ${skuCode}`, error);
    //         return item; // Return the original item if fetch fails
    //       }
    //     })
    //   );

    //   // Update the list with vendor options
    //   setList(updatedList);
    //   // Loop through each SKU code and fetch vendor options
    //   // const updatedList = await Promise.all(
    //   //   listData.map(async (item) => {
    //   //     const skuCode = item.skuCode;
    //   //     console.log("skucode inside updatedlist" , skuCode);
    //   //     try {
    //   //       const response = await getVendorSKUList2({ customerCode, skuCode: [skuCode], active });
    //   //       const vendorOptions = response.data.data.map(vendor => ({
    //   //         label: vendor.vendorCode,
    //   //         value: vendor.vendorCode
    //   //       }));

    //   //       // Add vendor options to the current item
    //   //       return {
    //   //         ...item,
    //   //         vendorOptions
    //   //       };
    //   //     } catch (error) {
    //   //       console.error(`Error fetching vendor list for SKU ${skuCode}`, error);
    //   //       return item; // Return the original item if the fetch fails
    //   //     }
    //   //   })
    //   // );

    //   // // Update the list with vendor options
    //   // setList(updatedList);
    // },
    onSuccess: (data) => setList(data.data.data),
    onError,
  });

  const [openPdfDialog, setOpenPdfDialog] = useState(false);
const [pdfTitle, setPdfTitle] = useState("Latest Count Data");
const [selectedColumns, setSelectedColumns] = useState(
  exportColumns.map((col) => col.accessorKey)
);

const handleColumnToggle = (key) => {
  setSelectedColumns((prev) =>
    prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
  );
};



  const updateFinalCountListMutation = useMutation(updateFinalCountList, {
    onSuccess: (list) => {
      queryClient.invalidateQueries(["count-list2"]);
      setAlert(<Success data={list} onChange={setAlert} />);
      refetch();
    },
    onError,
  });

  const updateFinalCountListMutationStatus = updateFinalCountListMutation.status === "loading"

  const onSubmit = () => {
    console.log("beforewrap", list);
    const validatedList = list.map((item) => ({
      ...item,
      vendorCode: item.vendorCode?.value || item.vendorCode,
    }));
    console.log("validatedlist", validatedList);
    updateFinalCountListMutation.mutate(validatedList);
  };

  const handleretrieve = () => {
    refetch();
  };

  // useEffect(() => {
  const fetchVendorList = async (skuCode) => {
    console.log("skuCode being passed:", skuCode); // Log the skuCodes
    try {
      const response = await getVendorSKUList2({ customerCode, skuCode, active });
      console.log("Vendor list response:", response); // Log the response
      //setVendorOptions(response.data.data.map(vendor => ({
      return response.data.data.map((vendor) => ({
        label: vendor.vendorCode, // Adjust based on actual vendor properties
        value: vendor.vendorCode, // Adjust based on actual vendor properties
      }));
    } catch (error) {
      console.error("Error fetching vendor list", error);
      // Handle error appropriately
    }
  };

  // const fetchVendorList = async (skuCodes) => {
  //   try {
  //     const response = await getVendorSKUList2({ customerCode, skuCodes, active });
  //     console.log("Vendor list response:", response); // Log the response

  //     const vendorOptionsMap = response.data.data.reduce((map, vendor) => {
  //       map[vendor.skuCode] = {
  //         label: vendor.vendorCode,
  //         value: vendor.vendorCode
  //       };
  //       return map;
  //     }, {});

  //     // Update the list with the corresponding vendor options
  //     setList((prevList) => prevList.map(item => ({
  //       ...item,
  //       vendorCode: vendorOptionsMap[item.skuCode] || { label: '', value: '' }
  //     })));
  //   } catch (error) {
  //     console.error("Error fetching vendor list", error);
  //     // Handle error appropriately
  //   }
  // };

  //   fetchVendorList();
  // }, []);

  const handleVendorCodeChange = (value, rowIndex) => {
    setList((prevList) => {
      const newList = [...prevList];
      newList[rowIndex] = {
        ...newList[rowIndex],
        vendorCode: { label: value, value: value },
      };
      return newList;
    });
  };

  // const handleDownload = () => {
  //   retrieveLatestCountList({ pnos, customerCode }).then((response) => {
  //     const blob = new Blob([response.data], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });
  //     const url = window.URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", `LatestPCountList.xlsx`);
  //     document.body.appendChild(link);
  //     link.click();
  //   });
  // };

  const handleDownload = () => {
  retrieveLatestCountList({ pnos, customerCode, data: filteredData }).then((response) => {
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `LatestPCountList.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};

  

  const totals = useMemo(() => {
    return list.reduce(
      (acc, item) => {
        acc.sysQty += Number(item.sysQty) || 0;
      acc.phyQty += Number(item.phyQty) || 0;
      acc.variance += Number(item.variance) || 0;
        return acc;
      },
      { sysQty: 0, phyQty: 0, variance: 0 } // Initial values
    );
  }, [list]);

  const handleExportPDF = () => {
    console.log("filteredData sample:", filteredData[0]); // <-- add this
  const doc = new jsPDF({ orientation: "landscape" });
  const pageWidth = doc.internal.pageSize.getWidth();

  // --- Left side: Title + subtitle ---
  doc.setFontSize(14);
  doc.setFont(undefined, "bold");
  doc.text(pdfTitle, 14, 15);

  doc.setFontSize(10);
  doc.setFont(undefined, "normal");
  doc.text(`Physical Count No : ${pnos || ""}`, 14, 21);

  // --- Right side: Date / Page / Printed By ---
  const now = new Date();
  const formattedDate = now
    .toLocaleString("en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    })
    .replace(",", "");

  doc.setFontSize(10);
  doc.text(`Date : ${formattedDate}`, pageWidth - 14, 12, { align: "right" });
  //doc.text(`Printed By : ${printedBy || ""}`, pageWidth - 14, 22, { align: "right" });

  // --- Table ---
  const columnsToExport = exportColumns.filter((col) =>
    selectedColumns.includes(col.accessorKey)
  );

  const head = [columnsToExport.map((col) => col.header)];
  const body = filteredData.map((row) =>
    columnsToExport.map((col) => {
      const value = row[col.accessorKey];
      if (col.accessorKey === "expiryDate") {
        return value ? new Date(value).toLocaleDateString("en-GB") : "";
      }
      if (col.accessorKey === "vendorCode") {
        return value?.value || value || "";
      }
      return value ?? "";
    })
  );

  autoTable(doc, {
    head,
    body,
    startY: 28,
    styles: { fontSize: 8 },
    headStyles: { fillColor: [26, 115, 232] },
  });

  // --- Totals footer (last page only, right after the table ends) ---
const finalY = doc.lastAutoTable.finalY || 28;
const pageHeight = doc.internal.pageSize.getHeight();

// If the table ends too close to the bottom of the page, add a new page for the footer
let footerY = finalY + 10;
if (footerY > pageHeight - 15) {
  doc.addPage();
  footerY = 15;
}

doc.setFontSize(9);
doc.setFont(undefined, "bold");
doc.text(`Total SysQty: ${totals.sysQty}`, 14, footerY);
doc.text(`Total CountQty: ${totals.phyQty}`, 80, footerY);
doc.text(`Total Variance: ${totals.variance}`, 150, footerY);

  // --- Page numbers ---
  // const pageCount = doc.internal.getNumberOfPages();
  // for (let i = 1; i <= pageCount; i++) {
  //   doc.setPage(i);
  //   doc.setFontSize(10);
  //   doc.text(`Page : ${i} / ${pageCount}`, pageWidth - 14, 17, { align: "right" });
  // }

  doc.save(`${pdfTitle.replace(/\s+/g, "_")}.pdf`);
  setOpenPdfDialog(false);
};

  return (
    <>
      {(isFetching || updateFinalCountListMutationStatus) && <LoadingDialog />}
      {alert}
      {/* <BasicTable sx={{ mt: "1rem" }} {...tableProps} 
      //onFilterRowsChange={handleChange} 
      /> */}
      {/* <Grid container spacing={2} alignItems="center" justifyContent="space-between" sx={{ mt: "1rem" }}>
      <Grid item>
        <MDButton color="info" variant="gradient" onClick={onSubmit} disabled={list.length === 0 || type!=="ALL"}>
            Upload
          </MDButton>
          </Grid>
          </Grid> */}

      <TableCard sx={{ mt: "1rem" }}>
        <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" margin="10px">
       <div>
  <MDButton
    color="info"
    variant="gradient"
    onClick={handleDownload}
    disabled={customerCode === null}
    sx={{ mr: 2 }}
  >
    Export Excel
  </MDButton>
  <MDButton
    color="info"
    variant="gradient"
    onClick={() => setOpenPdfDialog(true)}
    disabled={customerCode === null}
    sx={{ mr: 2 }}
  >
    Export PDF
  </MDButton>
</div>

  {/* Right Section: Quantities */}
  <div style={{ display: "flex", gap: "2rem", textAlign: "right" }}>
    <div>
      <strong>Total SysQty:</strong> {totals.sysQty}
    </div>
    <div>
      <strong>Total CountQty:</strong> {totals.phyQty}
    </div>
    <div>
      <strong>Total Variance:</strong> {totals.variance}
    </div>
  </div>
        </MDBox>
        <CheckboxTable2 data={list} columns={latestCountListcolumns2} setData={setList} onFilterRowsChange={setFilteredData}/>
      </TableCard>
      <Dialog open={openPdfDialog} onClose={() => setOpenPdfDialog(false)} maxWidth="xs" fullWidth>
  <DialogTitle>Export to PDF</DialogTitle>
  <DialogContent>
    <TextField
      margin="dense"
      label="PDF Title"
      fullWidth
      value={pdfTitle}
      onChange={(e) => setPdfTitle(e.target.value)}
      sx={{ mb: 2 }}
    />
    <strong>Select Columns</strong>
    <FormGroup>
      {exportColumns.map((col) => (
        <FormControlLabel
          key={col.accessorKey}
          control={
            <Checkbox
              checked={selectedColumns.includes(col.accessorKey)}
              onChange={() => handleColumnToggle(col.accessorKey)}
            />
          }
          label={col.header}
        />
      ))}
    </FormGroup>
  </DialogContent>
  <DialogActions>
    <MDButton color="secondary" variant="gradient" onClick={() => setOpenPdfDialog(false)}>
      Cancel
    </MDButton>
    <MDButton
      color="info"
      variant="gradient"
      onClick={handleExportPDF}
      disabled={selectedColumns.length === 0}
    >
      Export
    </MDButton>
  </DialogActions>
</Dialog>
      <InboundSubmitButton label="Update" onClick={onSubmit} disabled={!editPermission} />
    </>
  );
}

function Consolidate({ pnos, customerCode, zoneID, onError, refetchPNo, editPermission, setSelectedPNO}) {
  const [list, setList] = useState([]);
  // const [filteredData, setFilteredData] = useState([]);
  // const [columnFilter, setColumnFilter] = useState([{ id: "zoneID", value: zoneID }]);
  const [alert, setAlert] = useState(null);
  const [reasoncodes, setReasonCodes] = useState([]);
  const [selectedReasonCode, setSelectedReasonCode] = useState("");
  const { isFetching, refetch } = useQuery({
    queryKey: ["phyopnbalscan-details",{pnos}],
    queryFn: () => getPhyOpnBalScan({ customerCode, pnos }),
    enabled: !!pnos,
    onSuccess: (data) => setList(data.data.data),
    //onError,
    onError: (error) => onError(error, setAlert),
  });

  const consolidateMutation = useMutation(consolidate, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
      setSelectedReasonCode(null);
      refetchPNo();
      setSelectedPNO(null);
    },
    //onError,
    onError: (error) => onError(error, setAlert),
  });
  
  const consolidateMutationStatus = consolidateMutation.status === "loading"
  console.log(consolidateMutation.status);
  
  const onconsolidate = () => {
    console.log({ pnos, customerCode, selectedReasonCode: selectedReasonCode.value });
    consolidateMutation.mutate({ pnos, customerCode, reasonCode: selectedReasonCode.value });
  };

  // useEffect(() => {
  //   if (pnos) {
  //     refetch(); // Refetch data whenever pnos changes
  //   }
  // }, [pnos, refetch]);

  const forcecloseMutation = useMutation(forceclose, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
      setSelectedReasonCode(null);
      refetchPNo();
      setSelectedPNO(null);
    },
    //onError,
    onError: (error) => onError(error, setAlert),
  });

  const forcecloseMutationStatus = forcecloseMutation.status === "loading"

  const onforceclose = () => {
    console.log({ pnos, customerCode });
    forcecloseMutation.mutate({ pnos, customerCode });
  };

  const { refetch: refetchReasonCode } = useQuery({
    queryKey: ["ReasonCodeOption"],
    queryFn: () => getadjustmentreasoncode(),
    enabled: false,
    onSuccess: (data) => {
      console.log(data);
      setReasonCodes(
        data.data.data.map((item) => ({
          label: item.description1, // Adjust this to the column you want to display
          value: item.id, // Or any other identifier you need
        }))
      );
    },
    onError: (error) => onError(error, setAlert),
  });

  useEffect(() => {
    refetchReasonCode(); // Fetch reason codes when the component mounts
  }, [refetchReasonCode]);

  return (
    <>
      {(isFetching || consolidateMutationStatus || forcecloseMutationStatus) && <LoadingDialog />}
      {alert}
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        sx={{ mt: "0.2rem", mb: "0.2rem" }}
      >
        <Grid item xs={12}>
          <SelectFields
            field={{
              name: "",
              label: "Reason Code",
              value: selectedReasonCode,
              errors: {},
            }}
            options={reasoncodes}
            onChange={(e, v) => {
              console.log("Selected Reason Code:", v); // Log the selected reason code
              setSelectedReasonCode(v);
            }}
          />
        </Grid>
      </Grid>
      {/* <MDBox display="flex" justifyContent="center" alignItems="center"> */}
        <MDButton
          color="info"
          variant="gradient"
          onClick={onconsolidate}
          disabled={
            (!selectedReasonCode ||
                   selectedReasonCode.value === null ||
                   selectedReasonCode.value.trim() === "" ||
                   pnos === null ||
                   pnos.trim() === "" ||
                    consolidateMutationStatus)
          }
          // disabled={
          //   (!selectedReasonCode ||
          //     selectedReasonCode.value === null ||
          //     selectedReasonCode.value.trim() === "" ||
          //     pnos === null ||
          //     pnos.trim() === "") &&
          //   !editPermission
          // }
          //disabled={pnos === null || pnos.trim() === ""}
          style={{ marginRight: "1rem" }}
        >
          Consolidate
        </MDButton>
        <MDButton
          color="info"
          variant="gradient"
          onClick={onforceclose}
          disabled={( pnos === null || pnos.trim() === "" || forcecloseMutationStatus)}
          //disabled={(pnos === null || pnos.trim() === "") && !editPermission}
        >
          Force Close
        </MDButton>
      {/* </MDBox> */}
    </>
  );
}

